import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports

function SpanLink() {
    this.defaultAttrs({
        href: 'data-span-link-href',
    });

    this.after('initialize', function() {
        this.on('click', this.goToLink);
    });

    this.goToLink = function(e) {
        e.preventDefault();
        location.href = this.$node.attr(this.attr.href);
    };
}

export default defineComponent(SpanLink);



// WEBPACK FOOTER //
// ./src/js/component_ui/span-link.js